module.exports = {
      id: "refresh-icon-usage",
      viewBox: "0 0 18 18",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#refresh-icon",
      toString: function () {
        return this.url;
      }
    }